module.exports = __webpack_public_path__ + "img/no-search-results.b286e0c8.gif";